<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Transplant Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-2 fieldName">
            In OATS
          </div>
        </div>
        <div class="row" v-if="organ !== 'Heart' && organ !== 'Pancreas' && organ !== 'Intestine'">
          <div class="col-3">
            <ADSTextInput
              v-model="transplantType"
              disabled
              label="Transplant Type"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="transplantTypeOATS"
              disabled
              label="Transplant Type"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="transplantStartDate"
              disabled
              label="Transplant Start Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="transplantStartDateOATS"
              disabled
              label="Transplant Start Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="transplantStartTime"
              disabled
              label="Transplant Start Time"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="transplantStartTimeOATS"
              disabled
              label="Transplant Start Time"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="transplantDate"
              disabled
              label="Transplant Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="transplantDateOATS"
              disabled
              label="Transplant Date"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              v-model="portalVeinCrossClampDate"
              disabled
              label="Portal Vein Cross Clamp Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="portalVeinCrossClampDateOATS"
              disabled
              label="Portal Vein Cross Clamp Date"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              v-model="portalVeinCrossClampTime"
              disabled
              label="Portal Vein Cross Clamp Time"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="portalVeinCrossClampTimeOATS"
              disabled
              label="Portal Vein Cross Clamp Time"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              v-model="portalVeinClampRemovalDate"
              disabled
              label="Portal Vein Clamp Removal Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="portalVeinClampRemovalDateOATS"
              disabled
              label="Portal Vein Clamp Removal Date"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              v-model="portalVeinClampRemovalTime"
              disabled
              label="Portal Vein Clamp Removal Time"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="portalVeinClampRemovalTimeOATS"
              disabled
              label="Portal Vein Clamp Removal Time"
            />
          </div>
        </div>

        <div class="row" v-if="organ !== 'Heart' && organ !== 'Lung'">
          <div class="col-3">
            <ADSTextInput
              v-model="vesselUsed"
              disabled
              label="Vessel Used"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="vesselUsedOATS"
              disabled
              label="Vessel Used"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              v-model="hepaticArteryClampRemovalDate"
              disabled
              label="Hepatic Artery Clamp Removal Date"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="hepaticArteryClampRemovalDateOATS"
              disabled
              label="Hepatic Artery Clamp Removal Date"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              v-model="hepaticArteryClampRemovalTime"
              disabled
              label="Hepatic Artery Clamp Removal Time"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="hepaticArteryClampRemovalTimeOATS"
              disabled
              label="Hepatic Artery Clamp Removal Time"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              v-model="perfusionPumpDate"
              disabled
              label="Normothermic Perfusion Pump Removal Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="perfusionPumpDateOATS"
              disabled
              label="Normothermic Perfusion Pump Removal Date"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              v-model="perfusionPumpTime"
              disabled
              label="Normothermic Perfusion Pump Removal Time"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="perfusionPumpTimeOATS"
              disabled
              label="Normothermic Perfusion Pump Removal Time"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Kidney' && ( transplantColdDateRightKidney === null || transplantColdDateRightKidney === undefined || transplantColdDateRightKidney === '' )">
          <div class="col-3">
            <ADSTextInput
              v-model="transplantColdDateLeftKidney"
              disabled
              label="Removed from Cold Date - Left Kidney"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="transplantColdDateLeftKidneyOATS"
              disabled
              label="Removed from Cold Date - Left Kidney"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              v-model="removedFromColdDateLiver"
              disabled
              label="Removed from Cold Date"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="transplantColdDateLiverOATS"
              disabled
              label="Removed from Cold Date"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Kidney' && ( transplantColdDateRightKidney === null || transplantColdDateRightKidney === undefined || transplantColdDateRightKidney === '' )">
          <div class="col-3">
            <ADSTextInput
              v-model="transplantColdTimeLeftKidney"
              disabled
              label="Removed from Cold Time - Left Kidney'"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="transplantColdTimeLeftKidneyOATS"
              disabled
              label="Removed from Cold Time - Left Kidney'"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              v-model="removedFromColdTimeLiver"
              disabled
              label="Removed from Cold Time"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="transplantColdTimeLiverOATS"
              disabled
              label="Removed from Cold Time"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Kidney' && ( transplantColdDateLeftKidney === null || transplantColdDateLeftKidney === undefined || transplantColdDateLeftKidney === '' )">
          <div class="col-3">
            <ADSTextInput
              v-model="transplantColdDateRightKidney"
              disabled
              label="Removed from Cold Date - Right Kidney"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="transplantColdDateRightKidneyOATS"
              disabled
              label="Removed from Cold Date - Right Kidney"
            />
          </div>
        </div>

        <div class="row" v-if="organ === 'Kidney' && ( transplantColdDateLeftKidney === null || transplantColdDateLeftKidney === undefined || transplantColdDateLeftKidney === '' )">
          <div class="col-3">
            <ADSTextInput
                v-model="transplantColdTimeRightKidney"
                disabled
              label="Removed from Cold Time - Right Kidney"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="transplantColdTimeRightKidneyOATS"
              disabled
              label="Removed from Cold Time - Right Kidney"
            />
          </div>
        </div>
        <div class="row" v-if="organ === 'Kidney' && ( clampRemovalDateRightKidney === null || clampRemovalDateRightKidney === undefined || clampRemovalDateRightKidney === '' )">
          <div class="col-3">
            <ADSTextInput
              v-model="clampRemovalDateLeftKidney"
              disabled
              label="Clamp Removal Date - Left Kidney"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="clampRemovalDateLeftKidneyOATS"
              disabled
              label="Clamp Removal Date - Left Kidney"
            />
          </div>
        </div>
        <div class="row" v-if="organ === 'Kidney' && ( clampRemovalDateRightKidney === null || clampRemovalDateRightKidney === undefined || clampRemovalDateRightKidney === '' )">
          <div class="col-3">
            <ADSTextInput
              v-model="clampRemovalTimeLeftKidney"
              disabled
              label="Clamp Removal Time - Left Kidney"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="clampRemovalTimeLeftKidneyOATS"
              disabled
              label="Clamp Removal Time - Left Kidney"
            />
          </div>
        </div>
        <div class="row" v-if="organ === 'Kidney' && ( clampRemovalDateLeftKidney === null || clampRemovalDateLeftKidney === undefined || clampRemovalDateLeftKidney === '' )">
          <div class="col-3">
            <ADSTextInput
              v-model="clampRemovalDateRightKidney"
              disabled
              label="Clamp Removal Date - Right Kidney"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="clampRemovalDateRightKidneyOATS"
              disabled
              label="Clamp Removal Date - Right Kidney"
            />
          </div>
        </div>
        <div class="row" v-if="organ === 'Kidney' && ( clampRemovalDateLeftKidney === null || clampRemovalDateLeftKidney === undefined || clampRemovalDateLeftKidney === '' )">
          <div class="col-3">
            <ADSTextInput
              v-model="clampRemovalTimeRightKidney"
              disabled
              label="Clamp Removal Time - Right Kidney"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="clampRemovalTimeRightKidneyOATS"
              disabled
              label="Clamp Removal Time - Right Kidney"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';
import { ORGAN_LIST } from '../constants';

export default {
  name: "TransplantSectionDetailsEMROATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    },
    organ: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      transplantType: this.getTransplantType( this.patientBundle ),
      transplantTypeOATS: this.getTransplantTypeOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      transplantStartDate: this.getTransplantStartDate( this.patientBundle ),
      transplantStartDateOATS: this.getTransplantStartDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      transplantStartTime: this.getTransplantStartTime( this.patientBundle )?.substring( 0, 5 ),
      transplantStartTimeOATS: this.getTransplantStartTimeOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      transplantDate: this.getTransplantDate( this.patientBundle ),
      transplantDateOATS: this.getTransplantDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      transplantColdDateLeftKidney: this.getTransplantColdDateLeftKidney( this.patientBundle ),
      removedFromColdDateLiver: this.getRemovedFromColdDateLiver( this.patientBundle ),
      removedFromColdTimeLiver: this.getRemovedFromColdTimeLiver( this.patientBundle )?.substring( 0, 5 ),
      transplantColdTimeLeftKidney: this.getTransplantColdTimeLeftKidney( this.patientBundle )?.substring( 0, 5 ),
      transplantColdDateLeftKidneyOATS: this.getTransplantColdDateLeftKidneyOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      transplantColdDateLiverOATS: this.getTransplantColdDateLiverOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      transplantColdTimeLiverOATS: this.getTransplantColdTimeLiverOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      transplantColdTimeLeftKidneyOATS: this.getTransplantColdTimeLeftKidneyOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      transplantColdDateRightKidney: this.getTransplantColdDateRightKidney( this.patientBundle ),
      transplantColdTimeRightKidney: this.getTransplantColdTimeRightKidney( this.patientBundle )?.substring( 0, 5 ),
      transplantColdDateRightKidneyOATS: this.getTransplantColdDateRightKidneyOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      transplantColdTimeRightKidneyOATS: this.getTransplantColdTimeRightKidneyOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      clampRemovalDateLeftKidney: this.getClampRemovalDateLeftKidney( this.patientBundle, this.organ ),
      clampRemovalTimeLeftKidney: this.getClampRemovalTimeLeftKidney( this.patientBundle, this.organ )?.substring( 0, 5 ),
      clampRemovalTimeLeftKidneyOATS: this.getClampRemovalTimeLeftKidneyOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      clampRemovalDateLeftKidneyOATS: this.getClampRemovalDateLeftKidneyOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      clampRemovalDateRightKidney: this.getClampRemovalDateRightKidney( this.patientBundle ),
      clampRemovalTimeRightKidney: this.getClampRemovalTimeRightKidney( this.patientBundle )?.substring( 0, 5 ),
      clampRemovalDateRightKidneyOATS: this.getClampRemovalDateRightKidneyOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      clampRemovalTimeRightKidneyOATS: this.getClampRemovalTimeRightKidneyOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      vesselUsed: this.getVesselUsed( this.patientBundle ),
      vesselUsedOATS: this.getVesselUsedOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      portalVeinCrossClampDate: this.getPortalVeinCrossClampDate( this.patientBundle ),
      portalVeinCrossClampTime: this.getPortalVeinCrossClampTime( this.patientBundle )?.substring( 0, 5 ),
      portalVeinCrossClampTimeOATS: this.getPortalVeinCrossClampTimeOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      portalVeinCrossClampDateOATS: this.getPortalVeinCrossClampDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      perfusionPumpDate: this.getPerfusionPumpDate( this.patientBundle ),
      perfusionPumpDateOATS: this.getPerfusionPumpDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      perfusionPumpTime: this.getPerfusionPumpTime( this.patientBundle )?.substring( 0, 5 ),
      perfusionPumpTimeOATS: this.getPerfusionPumpTimeOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      portalVeinClampRemovalDate: this.getPortalVeinClampRemovalDate( this.patientBundle ),
      portalVeinClampRemovalDateOATS: this.getPortalVeinClampRemovalDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      portalVeinClampRemovalTime: this.getPortalVeinClampRemovalTime( this.patientBundle )?.substring( 0, 5 ),
      portalVeinClampRemovalTimeOATS: this.getPortalVeinClampRemovalTimeOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      hepaticArteryClampRemovalDate: this.getHepaticArteryClampRemovalDate( this.patientBundle ),
      hepaticArteryClampRemovalDateOATS: this.getHepaticArteryClampRemovalDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      hepaticArteryClampRemovalTime: this.getHepaticArteryClampRemovalTime( this.patientBundle )?.substring( 0, 5 ),
      hepaticArteryClampRemovalTimeOATS: this.getHepaticArteryClampRemovalTimeOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getRemovedFromColdDateLabel() {
      return this.organ === 'Kidney' ? 'Removed from Cold Date - Left Kidney' : 'Removed from Cold Date';
    },
    getRemovedFromColdTimeLabel() {
      return this.organ === 'Kidney' ? 'Removed from Cold Time - Left Kidney' : 'Removed from Cold Time';
    },
    getEpisodePhase( patientBundle ) {
      if ( !patientBundle?.entries ) {
        return;
      }
      let episodeOfCares = patientBundle.entries.filter( ( n ) => (
        _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' 
      ) );
      if ( !( episodeOfCares?.[0]?.[0] ) ) {
        return;
      }
      const episodeOfCare = episodeOfCares[0].filter( ( n ) => ( _.get( n, 'resource.id' ) === patientBundle.episode_id ) );
      if ( !( episodeOfCare ) ) {
        return;
      }
      const extensions = episodeOfCare?.[ 0 ]?.resource?.extension;
      if ( !extensions ) {
        return;
      }
      for ( const item of extensions ) {
        if ( item.url?.includes( 'transplant-phase-status' ) && item.extension?.length ) {
          const phaseExt = item.extension.filter( ( ext ) => ext.url === 'phase' );
          if ( phaseExt?.[0] ) {
            return _.get( phaseExt[0], 'valueCodeableConcept.coding[0].code' );
          }
        }
      }
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getTransplantType( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8301' );
    },
    getTransplantTypeOATS( patientBundleOATS, organ, patientBundle ) {
      const organSpecificationCodeToLabel = {
        '311': 'Kidney - Right',
        '312': 'Kidney - Left',
        '101': 'Liver - Whole',
        '102': 'Liver – Right Segment',
        '103': 'Liver - Left segment',
        '452': 'Lung - Right Lobe',
        '453': 'Lung - Left Lobe',
        '402': 'Right Lung',
        '403': 'Lung - Left',
        '401': 'Lung - Both',
      };

      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          const code = journey[ 0 ].stage_attributes?.transplant?.organ_specification_code;
        const codeStr = code === null || code === undefined ? null : String( code );
        if( !codeStr ) return null;
        return organSpecificationCodeToLabel[ codeStr ] ?? codeStr;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] ) {
              const code = journey[ 0 ].stage_attributes?.transplant?.organ_specification_code;
              const codeStr = code === null || code === undefined ? null : String( code );
              if( !codeStr ) return null;
              return organSpecificationCodeToLabel[ codeStr ] ?? codeStr;
            }
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] ) {
              const code = journey[ 0 ].stage_attributes?.transplant?.organ_specification_code;
              const codeStr = code === null || code === undefined ? null : String( code );
              if( !codeStr ) return null;
              return organSpecificationCodeToLabel[ codeStr ] ?? codeStr;
            }
          }
        }
      }
    },
    getTransplantStartDate( patientBundle ) {
      if( this.getSmartdataComponentValue( patientBundle, 'SK#8084', 'valueDateTime' ) === null )
      { return null; }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8084', 'valueDateTime' );
    },
    getTransplantStartTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8085', 'valueTime' )?.substring( 0, 5 );
    },
    getTransplantStartDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.transplant_start_date )?.date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.transplant_start_date )?.date;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.transplant_start_date )?.date;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.transplant_start_date )?.date;
      }
    },
    getTransplantStartTimeOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.transplant_start_date )?.time;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.transplant_start_date )?.time;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.transplant_start_date )?.time;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.transplant_start_date )?.time;
      }
    },
    getTransplantDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8299', 'valueDateTime' );
    },
    getTransplantDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.transplant?.factors?.transplant_date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.transplant?.factors?.transplant_date
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.transplant?.factors?.transplant_date
          } 
        }
        return journey[ 0 ].stage_attributes?.transplant?.factors?.transplant_date;
      }
    },
    getPortalVeinCrossClampDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.portal_vein_cross_clamp_date )?.date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.portal_vein_cross_clamp_date )?.date;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.portal_vein_cross_clamp_date )?.date;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.portal_vein_cross_clamp_date )?.date;
      }
    },
    getPortalVeinCrossClampTimeOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.portal_vein_cross_clamp_date )?.time;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.portal_vein_cross_clamp_date )?.time;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.portal_vein_cross_clamp_date )?.time;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.portal_vein_cross_clamp_date )?.time;
      }
    },
    getPortalVeinClampRemovalDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.pv_clamp_off_date )?.date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.pv_clamp_off_date )?.date;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.pv_clamp_off_date )?.date;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.pv_clamp_off_date )?.date;
      }
    },
    getPortalVeinClampRemovalTimeOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.pv_clamp_off_date )?.time;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.pv_clamp_off_date )?.time;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.pv_clamp_off_date )?.time;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.pv_clamp_off_date )?.time;
      }
    },
    getVesselUsedOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      const getVesselUsedLabel = ( vesselsUsed ) => {
        if( vesselsUsed == null || vesselsUsed === '' ) {
          return '';
        }
        return vesselsUsed ? 'Checked' : 'Unchecked';
      };
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return getVesselUsedLabel( journey[ 0 ].stage_attributes?.transplant?.vessels_used );
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return getVesselUsedLabel( journey[ 0 ].stage_attributes?.transplant?.vessels_used );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return getVesselUsedLabel( journey[ 0 ].stage_attributes?.transplant?.vessels_used );
          } 
        }
        return getVesselUsedLabel( journey[ 0 ].stage_attributes?.transplant?.vessels_used );
      }
    },
    getHepaticArteryClampRemovalDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.ha_clamp_off_date )?.date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.ha_clamp_off_date )?.date;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.ha_clamp_off_date )?.date;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.ha_clamp_off_date )?.date;
      }
    },
    getHepaticArteryClampRemovalTimeOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.ha_clamp_off_date )?.time;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.ha_clamp_off_date )?.time;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.ha_clamp_off_date )?.time;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.ha_clamp_off_date )?.time;
      }
    },
    getPerfusionPumpDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.removed_from_normothermic_perf_pump_date )?.date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.removed_from_normothermic_perf_pump_date )?.date;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.removed_from_normothermic_perf_pump_date )?.date;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.removed_from_normothermic_perf_pump_date )?.date;
      }
    },
    getPerfusionPumpTimeOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.removed_from_normothermic_perf_pump_date )?.time;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.removed_from_normothermic_perf_pump_date )?.time;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) )
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.removed_from_normothermic_perf_pump_date )?.time;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.removed_from_normothermic_perf_pump_date )?.time;
      }
    },
    getTransplantColdDateLeftKidney( patientBundle ) {
      if( this.getSmartdataComponentValue( patientBundle, 'SK#8303', 'valueDateTime' ) === null )
      { return null; }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8303', 'valueDateTime' );
    },
    getTransplantColdTimeLeftKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8304', 'valueTime' );
    },
    getRemovedFromColdDateLiver( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8321', 'valueDateTime' );
    },
    getRemovedFromColdTimeLiver( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8322', 'valueTime' );
    },
    _getEndColdStorageLeftKidOatsAdjusted( transplant ) {
      const raw = transplant?.end_cold_storage_date_left_kid;
      if( !raw ) return null;
      const ms = Date.parse( raw );
      if( Number.isNaN( ms ) ) {
        return {
          date: raw.length >= 10 ? raw.substring( 0, 10 ) : null,
          time: raw.length >= 16 ? raw.substring( 11, 16 ) : null,
        };
      }
      const adjusted = new Date( ms - ( 4 * 60 ) * 60 * 1000 );
      const y = adjusted.getUTCFullYear();
      const mo = String( adjusted.getUTCMonth() + 1 ).padStart( 2, '0' );
      const d = String( adjusted.getUTCDate() ).padStart( 2, '0' );
      const hh = String( adjusted.getUTCHours() ).padStart( 2, '0' );
      const mm = String( adjusted.getUTCMinutes() ).padStart( 2, '0' );
      return { date: `${y}-${mo}-${d}`, time: `${hh}:${mm}` };
    },
    _getOatsDateAdjusted( date ) {
      const raw = date;
      if( !raw ) return null;
      const ms = Date.parse( raw );
      if( Number.isNaN( ms ) ) {
        return {
          date: raw.length >= 10 ? raw.substring( 0, 10 ) : null,
          time: raw.length >= 16 ? raw.substring( 11, 16 ) : null,
        };
      }
      const adjusted = new Date( ms - ( 4 * 60 ) * 60 * 1000 );
      const y = adjusted.getUTCFullYear();
      const mo = String( adjusted.getUTCMonth() + 1 ).padStart( 2, '0' );
      const d = String( adjusted.getUTCDate() ).padStart( 2, '0' );
      const hh = String( adjusted.getUTCHours() ).padStart( 2, '0' );
      const mm = String( adjusted.getUTCMinutes() ).padStart( 2, '0' );
      return { date: `${y}-${mo}-${d}`, time: `${hh}:${mm}` };
    },
    getTransplantColdDateLeftKidneyOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getEndColdStorageLeftKidOatsAdjusted( journey[ 0 ].stage_attributes?.transplant )?.date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getEndColdStorageLeftKidOatsAdjusted( journey[ 0 ].stage_attributes?.transplant )?.date;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getEndColdStorageLeftKidOatsAdjusted( journey[ 0 ].stage_attributes?.transplant )?.date;
          } 
        }
        return this._getEndColdStorageLeftKidOatsAdjusted( journey[ 0 ].stage_attributes?.transplant )?.date;
      }
    },
    getTransplantColdDateLiverOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date )?.date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date )?.date;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date )?.date;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date )?.date;
      }
    },
    getTransplantColdTimeLiverOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date )?.time;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date )?.time;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date )?.time;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date )?.time;
      }
    },
    getTransplantColdTimeLeftKidneyOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getEndColdStorageLeftKidOatsAdjusted( journey[ 0 ].stage_attributes?.transplant )?.time;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getEndColdStorageLeftKidOatsAdjusted( journey[ 0 ].stage_attributes?.transplant )?.time;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getEndColdStorageLeftKidOatsAdjusted( journey[ 0 ].stage_attributes?.transplant )?.time;
          } 
        }
        return this._getEndColdStorageLeftKidOatsAdjusted( journey[ 0 ].stage_attributes?.transplant )?.time;
      }
    },
    getTransplantColdDateRightKidney( patientBundle ) {
      if( this.getSmartdataComponentValue( patientBundle, 'SK#8305', 'valueDateTime' ) === null )
      { return null; }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8305', 'valueDateTime' ) ;
    },
    getTransplantColdTimeRightKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8306', 'valueTime' );
    },
    getTransplantColdDateRightKidneyOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date_right_kid )?.date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date_right_kid )?.date;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date_right_kid )?.date;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date_right_kid )?.date;
      }
    },
    getTransplantColdTimeRightKidneyOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date_right_kid )?.time;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date_right_kid )?.time;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date_right_kid )?.time;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.end_cold_storage_date_right_kid )?.time;
      }
    },
    getClampRemovalDateLeftKidney( patientBundle, organ ) {
      if( organ === 'Kidney' ) {
        return this.getSmartdataComponentValue( patientBundle, 'SK#8307', 'valueDateTime' );
      }
      if( this.getSmartdataComponentValue( patientBundle, 'SK#8244', 'valueDateTime' ) === null )
      { return null; }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8244', 'valueDateTime' );
    },
    getClampRemovalTimeLeftKidney( patientBundle, organ ) {
      if( organ === 'Kidney' ) {
        return this.getSmartdataComponentValue( patientBundle, 'SK#8308', 'valueTime' );
      }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8245', 'valueTime' );
    },
    getClampRemovalDateLeftKidneyOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_left_kid )?.date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_left_kid )?.date;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_left_kid )?.date;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_left_kid )?.date;
      }
    },
    getClampRemovalTimeLeftKidneyOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_left_kid )?.time;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_left_kid )?.time;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
              return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_left_kid )?.time;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_left_kid )?.time;
      }
    },
    getClampRemovalDateRightKidneyOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_right_kid )?.date;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_right_kid )?.date;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_right_kid )?.date;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_right_kid )?.date;
      }
    },
    getClampRemovalTimeRightKidneyOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length === 1 ) {
          return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_right_kid )?.time;
        }
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_right_kid )?.time;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_right_kid )?.time;
          } 
        }
        return this._getOatsDateAdjusted( journey[ 0 ].stage_attributes?.transplant?.clamp_removal_date_right_kid )?.time;
      }
    },
    getClampRemovalDateRightKidney( patientBundle ) {
      if( this.getSmartdataComponentValue( patientBundle, 'SK#8309', 'valueDateTime' ) === null )
      { return null; }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8309', 'valueDateTime' );
    },
    getClampRemovalTimeRightKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8310', 'valueTime' );
    },
    getVesselUsed( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8311', 'valueBoolean' );
    },
    getPortalVeinCrossClampDate( patientBundle ) {

      if ( this.getSmartdataComponentValue( patientBundle, 'SK#8319', 'valueDateTime' ) === null )
      { return null; }

      return this.getSmartdataComponentValue( patientBundle, 'SK#8319', 'valueDateTime' );
    },
    getPortalVeinCrossClampTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8320', 'valueTime' );
    },
    getPerfusionPumpDate( patientBundle ) {
      if( this.getSmartdataComponentValue( patientBundle, 'SK#8323', 'valueDateTime' ) === null )
      { return null; }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8323', 'valueDateTime' );
    },
    getPerfusionPumpTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8324', 'valueTime' );
    },
    getPortalVeinClampRemovalDate( patientBundle ) {
      if( this.getSmartdataComponentValue( patientBundle, 'SK#8325', 'valueDateTime' ) === null )
      { return null; }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8325', 'valueDateTime' );
    },
    getPortalVeinClampRemovalTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8326', 'valueTime' );
    },
    getHepaticArteryClampRemovalDate( patientBundle ) {
      if( this.getSmartdataComponentValue( patientBundle, 'SK#8327', 'valueDateTime' ) === null )
      { return null; }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8327', 'valueDateTime' );
    },
    getHepaticArteryClampRemovalTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8328', 'valueTime' );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 1560px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
